import { render, staticRenderFns } from "./Pc2.vue?vue&type=template&id=6fcca9c8&scoped=true"
import script from "./Pc2.vue?vue&type=script&lang=js"
export * from "./Pc2.vue?vue&type=script&lang=js"
import style0 from "./Pc2.vue?vue&type=style&index=0&id=6fcca9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcca9c8",
  null
  
)

export default component.exports